import {
  getBillingUnpaidInvoicesApiRequest,
  postCollectBillingUnpaidInvoicesApiRequest,
} from '@/services/api/billing-api';
import { getUserApiRequest, putUserApiRequest } from '@/services/api/user-api';
import type { User } from '@/services/models';
import { useStore } from '@/store';
import { api } from '@/services/api/main/axios';

export class AppExeptionsDialogsApi {
  error: boolean = false;
  loading: boolean = false;
  tableLoading: boolean = false;

  collectUnpaidInvoices() {
    this.loading = true;

    return postCollectBillingUnpaidInvoicesApiRequest()
      .then((res) => Promise.resolve(res))
      .catch((error: unknown) => Promise.reject(error))
      .finally(() => {
        this.loading = false;
      });
  }

  getUnpaidInvoices(): Promise<Billing.UnpaidData> {
    return getBillingUnpaidInvoicesApiRequest()
      .then((res) => Promise.resolve(res as Billing.UnpaidData))
      .catch((error: unknown) => Promise.reject(error));
  }

  payPalCapture(payload: { orderID: string }) {
    return api
      .post('billing/paypal/capture', payload)
      .then((res) => Promise.resolve(res.data.payload))
      .catch((error: unknown) => Promise.reject(error));
  }

  updateUser() {
    this.loading = true;
    const store = useStore();

    return getUserApiRequest()
      .then((res) => {
        store.mergeUser(res);
        return Promise.resolve(res);
      })
      .catch((error: unknown) => Promise.reject(error))
      .finally(() => {
        this.loading = false;
      });
  }

  putUser(payload: Partial<User>) {
    this.loading = true;
    const store = useStore();

    return putUserApiRequest(payload)
      .then((res) => {
        store.mergeUser(res);
        return Promise.resolve(res);
      })
      .catch((error: unknown) => Promise.reject(error))
      .finally(() => {
        this.loading = false;
      });
  }

  shakeUser() {
    const store = useStore();
    const payload = {
      firstName: store.user.firstName,
    };

    return putUserApiRequest(payload)
      .then((res) => Promise.resolve(res))
      .catch((error: unknown) => Promise.reject(error));
  }
}

export default new AppExeptionsDialogsApi();
